<template>
<span id="add-bol-detail">
  <el-button
    id="btn-add-bol-detail"
    type="success"
    plain @click="dialogVisible = true"
    size="mini"
  >
    {{ $t('customerService.billOfLading.addBolDetail') }}
  </el-button>

  <el-dialog
    :close-on-click-modal="false"
    v-on:open="handleOpen"
    :title="$t('customerService.billOfLading.addBolDetail')"
    :visible.sync="dialogVisible"
    width="85%"
    class="dialog-with-cols"
    append-to-body
    :before-close="handleClose"
  >
  <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
          <el-col :md="7" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.shipper')" prop="shipperAccountId">
                  <autocomplete
                    :model.sync="form.shipperAccountId"
                    :url="urlShipper"
                    labelField="name"
                    labelFieldLastWithDash="number"
                    valueField="id"
                    id="form-consignee"
                    ref="form-consignee"/>
              </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12" :xs="24" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.consignee')" prop="consigneeAccountId">
                  <autocomplete
                    :disabled="!subAccount || (subAccount && !form.shipperAccountId)"
                    :model.sync="form.consigneeAccountId"
                    :url="urlConsignee"
                    :shipperAccountId="form.shipperAccountId"
                    labelField="name"
                    labelFieldLastWithDash="number"
                    valueField="id"
                    id="form-consignee"
                    ref="form-consignee"/>
              </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.units')" prop="totalUnits">
                  <el-input-number
                    v-model="form.totalUnits"
                    v-numeric-validation
                    :precision="0"
                    :min="0" :max="999"
                    @focus="$event.target.select()"
                    class="inline-input width-100p"
                    id="form-number-units"
                    ref="unit"
                  ></el-input-number>
              </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.farmName')" prop="farmName">
                  <autocomplete
                    :model.sync="form.farmName"
                    :strict="false"
                    :url="urlFarmName"
                    labelField="name"
                    labelfieldSelected="name"
                    valueField="id"
                    valueFieldAdditional="name"
                    :maxlength="100"
                    id="form-farm-name"
                    ref="form-farm-name"
                  />
              </el-form-item>
          </el-col>
          <el-col :md="3" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.poNumber')" prop="po">
                  <el-input
                    v-model="form.po"
                    v-alphanumeric-validation
                    maxlength="25"
                    clearable
                    class="inline-input"
                    id="form-po-number"
                  ></el-input>
              </el-form-item>
          </el-col>
      </el-row>
      <el-row>
          <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.unitOfMeasure')" prop="unitOfMeasure">
                  <el-select v-model="form.unitOfMeasure" id="form-unit-of-measure">
                      <el-option
                        v-for="item in unitOfMeasureOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                  </el-select>
              </el-form-item>
          </el-col>
          <el-col :md="3" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.measure')" prop="measure">
                  <el-select v-model="form.measure" id="form-measure">
                      <el-option
                        v-for="item in measureOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                  </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="2" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.length')" prop="length">
                  <el-input-number
                    v-model="form.length"
                    v-numeric-validation
                    :controls="false"
                    :precision="2"
                    @focus="$event.target.select()"
                    :min="0" :max="999.99"
                    class="inline-input width-100p"
                    id="form-length"
                    ref="length"
                  ></el-input-number>
              </el-form-item>
          </el-col>
          <el-col :md="2" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.width')" prop="width">
                  <el-input-number
                    v-model="form.width"
                    v-numeric-validation
                    :controls="false"
                    :precision="2"
                    :min="0" :max="999.99"
                    @focus="$event.target.select()"
                    class="inline-input width-100p"
                    id="form-width"
                    ref="width"
                  ></el-input-number>
              </el-form-item>
          </el-col>
          <el-col :md="2" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.height')" prop="height">
                  <el-input-number
                    v-model="form.height"
                    v-numeric-validation
                    :controls="false"
                    :precision="2"
                    :min="0" :max="999.99"
                    @focus="$event.target.select()"
                    class="inline-input width-100p"
                    id="form-height"
                    ref="height"
                  ></el-input-number>
              </el-form-item>
          </el-col>
          <el-col :md="4" :sm="12" :xs="12" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.productCode')" prop="productCode">
                  <autocomplete
                    :model.sync="form.productCode"
                    :modelAdditional.sync="form.productDescription"
                    :strict="false"
                    :url="urlProduct"
                    labelField="description"
                    labelFieldLastWithDash="code"
                    labelfieldSelected="code"
                    valueField="code"
                    valueFieldAdditional="description"
                    :maxlength="5"
                    id="form-product"
                    ref="form-product"
                  />
              </el-form-item>
          </el-col>
          <el-col :md="7" :sm="24" :xs="24" class="form-vertical-item">
              <el-form-item :label="$t('customerService.billOfLading.productName')" prop="productDescription">
                  <el-input
                    v-model="form.productDescription"
                    v-alphanumeric-validation
                    maxlength="30"
                    clearable
                    class="inline-input"
                    id="form-product-description"
                  ></el-input>
              </el-form-item>
          </el-col>
      </el-row>
  </el-form>
  <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-save-button" @click="submitForm()"
                 size="mini">{{ $t('customerService.billOfLading.addBolDetail') }}</el-button>
      <el-button id="form-refresh-button" @click="resetForm()" size="mini">
        {{ $t('common.clear') }}
      </el-button>
  </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

const formConsignee = 'form-consignee';

export default {
  components: { Autocomplete },
  props: {
    subAccount: {
      type: Boolean,
      default: false
    },
    billOfLadingId: {
      type: Number,
      default: 0
    },
  },
  computed: {
    unitOfMeasureOptions: () => constants.ORDER_ENTRY.UNIT_OF_MEASURE_LIST,
    measureOptions: () => constants.ORDER_ENTRY.MEASURE_LIST,
    urlConsignee: () => apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE_BY_SHIPPER,
    urlProduct: () => apiConstants.END_POINTS.PRODUCT_SEARCH,
    urlFarmName: () => apiConstants.END_POINTS.ACCOUNTS.FARM_NAME_SEARCH,
    urlShipper: () => apiConstants.END_POINTS.ACCOUNTS.SHIPPERS
  },
  data() {
    const totalUnitsValidate = (rule, value, callback) => {
      if (this.form.totalUnits === 0) {
        callback(new Error(this.$t('customerService.billOfLading.error.numberUnitsNotZero')));
      } else {
        callback();
      }
    };
    const consigneeValidate = (rule, value, callback) => {
      if (this.subAccount && !this.form.consigneeAccountId) {
        callback(new Error(this.$t('customerService.billOfLading.error.numberUnitsNotZero')));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      form: {
        shipperAccountId: null,
        consigneeAccountId: null,
        unitOfMeasure: constants.ORDER_ENTRY.UNIT_OF_MEASURE_LIST[0].value,
        measure: constants.ORDER_ENTRY.MEASURE_LIST[0].value,
        totalUnits: null,
        length: null,
        width: null,
        height: null,
        productCode: '',
        productDescription: '',
        po: '',
        farmName: ''
      },
      formRules: {
        shipperAccountId: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.shipperAccountRequired'),
            trigger: 'submit'
          }
        ],
        consigneeAccountId: [
          {
            required: this.subAccount,
            message: this.$t('customerService.billOfLading.error.consigneeAccountRequired'),
            trigger: 'submit'
          },
          {
            validator: consigneeValidate,
            trigger: 'submit'
          }
        ],
        unitOfMeasure: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.unitOfMeasureRequired'),
            trigger: 'blur'
          }
        ],
        length: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.lengthRequired'),
            trigger: 'blur'
          }
        ],
        width: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.widthRequired'),
            trigger: 'blur'
          }
        ],
        height: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.heightRequired'),
            trigger: 'blur'
          }
        ],
        totalUnits: [
          {
            required: true,
            message: this.$t('customerService.billOfLading.error.numberUnitsRequired'),
            trigger: 'blur'
          },
          {
            validator: totalUnitsValidate,
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        this.resetForm();
      });
    },
    handleClose(done) {
      this.$store.dispatch('billOfLading/search', {});
      this.dialogVisible = false;
      done();
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.consigneeAccountId = null;
      this.form.productCode = '';
      this.form.productDescription = '';
      this.$refs['form-product'].clearLocalModel();
      this.$refs[formConsignee].clearLocalModel();
      this.$refs['form-farm-name'].clearLocalModel();
    },
    submitForm() {
      return new Promise((resolve) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            Message.closeAll();
            const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
            this.$store
              .dispatch('billOfLading/addBolDetail', {
                billOfLadingId: this.billOfLadingId,
                detail: this.form
              })
              .then((response) => {
                loading.close();
                this.$message.success(response.message);
                this.resetForm();
                this.$emit('bolDetailAdded');
                resolve(response);
              })
              .catch((error) => {
                loading.close();
                resolve(error);
              });
          } else {
            resolve(new Error(this.$t('common.invalid')));
          }
        });
      });
    }
  }
};
</script>
